import './App.css';
import Weather from "./Weather";


export default function App() {
  return (
    <div className="App">
      <div className="container">
      <h1>Weather App</h1>
      <Weather defaultCity="Auckland"/>
      <footer>This project is coded by Richu, {" "}
      <a href = "https://github.com/RichuGanjoo/aaj-ka-weather" target="_blank" rel="noreferrer">Open sourced at Github...</a>
      
      </footer>
      </div>
    </div>
  );
}


